import { render, staticRenderFns } from "./entregado.vue?vue&type=template&id=423bb7b0&"
import script from "./entregado.vue?vue&type=script&lang=js&"
export * from "./entregado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports